import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css';
import $ from 'jquery';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { colourOptions } from './data/data';

const animatedComponents = makeAnimated();

class AddUserList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues:[]
        }
    }
    componentDidMount() {
        $(document).ready(function(){
            $('[data-toggle="tooltip"]').tooltip();   
          });
    }
    componentWillMount(){
        
    }
     handleChange = val => {
       
         this.setState({selectedValues: val})
        // setSelectedValue(e.value);
        
      }
      callUsers = () => {
          var userlist = [];
        this.state.selectedValues.map(list => 
            userlist.push(JSON.parse(list.value))
        )
        this.props.selectedUsers(userlist);
        return
      }
    render() {
      
        return (
            <div>

                {/* live user popup */}

                <div className="live_user-add" >
                <div className="c_container">
                    <div className="card">
                        <div className="card-body">
                        <button className="btn btn-round close" onClick={() => this.props.closeUserCallPopup()}>
                                        <svg fill="#B9312F" width="30px"  x="0px" y="0px" viewBox="0 0 512 512">
                                            		<path d="M437.019,74.981C388.668,26.628,324.378,0,256,0C187.62,0,123.333,26.628,74.981,74.98S0,187.62,0,256
			c0,68.381,26.628,132.668,74.981,181.02C123.332,485.372,187.62,512,255.999,512s132.669-26.628,181.02-74.98
			C485.371,388.667,512,324.38,512,256C512,187.619,485.371,123.332,437.019,74.981z M368.853,347.642
			c5.857,5.857,5.857,15.355,0,21.213c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393L256,277.214
			l-91.641,91.641c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393c-5.858-5.857-5.858-15.355,0-21.213
			l91.64-91.641l-91.64-91.641c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.857,15.354-5.857,21.213,0L256,234.788l91.64-91.641
			c5.857-5.857,15.355-5.857,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-91.641,91.641L368.853,347.642z"/>
</svg>
                                        </button>
                            <div className="text-center mt-3">
                                <div className="c_live_search_wrapper">
                                    <h3>Add people here</h3>
                                    <div className="mt-2">
                                <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={[]}
                                isMulti
                                options={this.props.options}
                                onChange={this.handleChange}
                                />
                                </div>
                                <button type="button" className="btn btn-success mt-2" style={{width:'200px', margin:'0 0 0 auto'}} onClick={this.callUsers} ><i className="mdi mdi-phone"></i> Call now</button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                </div>

                {/* video call grid */}

              </div>
        )
    }
}
export default AddUserList
